/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/Checkout/OnePageCheckout.Forms',[], function() {
    'use strict';

    // Forms fields configuration for data validation
    var forms = {
        recipientShippingAddress: {
            Fields: [
                {
                    "Name": 'First Name',
                    "Field": '#first-name-{id}',
                    "Param": 'firstName',
                    "Type": 'Text'
                },
                {
                    "Name": 'Last Name',
                    "Field": '#last-name-{id}',
                    "Param": 'lastName',
                    "Type": 'Text'
                },
                {
                    "Name": 'Company',
                    "Field": '#company-{id}',
                    "Param": 'company',
                    "Type": 'Text',
                    "Optional": true
                },
                {
                    "Name": 'Address 1',
                    "Field": '#address1-{id}',
                    "Param": 'address1',
                    "Type": 'Text',
                    "ShippingCalcReq": true,
                    "WipeOnCountryChange": true
                },
                {
                    "Name": 'Address 2',
                    "Field": '#address2-{id}',
                    "Param": 'address2',
                    "Type": 'Text',
                    "Optional": true,
                    "WipeOnCountryChange": true
                },
                {
                    "Name": 'Address 3',
                    "Field": '#address3-{id}',
                    "Param": 'address3',
                    "Type": 'Text',
                    "Optional": true,
                    "WipeOnCountryChange": true
                },
                {
                    "Name": 'City',
                    "Field": '#city-{id}',
                    "Param": 'city',
                    "Type": 'Text',
                    "ShippingCalcReq": true,
                    "WipeOnCountryChange": true
                },
                {
                    "Name": 'State',
                    "Field": '#state-{id}',
                    "Param": 'state',
                    "Type": 'Select',
                    "ShippingCalcReq": true,
                    "WipeOnCountryChange": true
                },
                {
                    "Name": 'Region',
                    "Field": '#region-{id}',
                    "Param": 'region',
                    "Type": 'Text',
                    "Optional": true,
                    "WipeOnCountryChange": true
                },
                {
                    "Name": 'Country',
                    "Field": '#country-{id}',
                    "Param": 'country',
                    "Type": 'Select',
                    "ShippingCalcReq": true
                },
                {
                    "Name": 'Zip/Postal Code',
                    "Field": '#zip-{id}',
                    "Param": 'zip',
                    "Type": 'Text',
                    "ShippingCalcReq": true,
                    "WipeOnCountryChange": true,
                    'Optional': true,
                    "Validators": [
                            {
                                'Type': 'RequiredIfField',
                                'ConditionalField': '#country-{id}',
                                'ConditionalFieldAttr': 'data-isPostalCodeRequired',
                                'ConditionalValue': 'true',
                                'ConditionalFieldType': 'Select'
                            },
                            {
                                "Type": 'Zip',
                                "ReferencedField": '#country-{id}',
                                'ReferencedFieldAttr': 'data-isPostalCodeRequired',
                                'ReferencedValue': 'true',
                                'ReferencedFieldType': 'Select'
                            }
                    ]
                },
                {
                    "Name": 'Phone',
                    "Field": '#phone-{id}',
                    "Param": 'phone',
                    "Type": 'Text'
                }
            ],
            Validate: true,
            RequestParam: 'shippingAddress'
        },
        recipientStorePickupData: {
            Fields: [
                {
                    "Name": 'First Name',
                    "Field": '#first-name-{id}',
                    "Param": 'firstName',
                    "Type": 'Text'
                },
                {
                    "Name": 'Last Name',
                    "Field": '#last-name-{id}',
                    "Param": 'lastName',
                    "Type": 'Text'
                },
                {
                    "Name": 'Phone',
                    "Field": '#phone-{id}',
                    "Param": 'phone',
                    "Type": 'Text'
                },
                {
                    "Name": 'Email',
                    "Field": '#email-{id}',
                    "Param": 'email',
                    "Type": 'Text',
                    "Validators": [
                        {
                            "Type": 'Email'
                        }
                    ]
                }
            ],
            Validate: true,
            RequestParam: 'storePickupData'
        },
        recipientSelectedShippingAddress: {
            Fields: [
                {
                    Name: 'Address',
                    Field: '#recipient-{id} .hdnSelectedShippingAddressBookId',
                    Param: 'address',
                    ShippingCalcReq: true,
                    Type: 'Hidden'
                }
            ],
            Validate: true,
            RequestParam: 'shippingAddressId',
            RequestParamType: 'SingleValue',
            ErrorMsg: 'Step {step}: Please select shipping address or add a new one'
        },
        selectedShippingMethod: {
            Fields: [
                {
                    Name: 'Delivery Method',
                    Field: '#recipient-{id} .hdnSelectedShippingMethodId',
                    Param: 'shippingMethod',
                    Type: 'Hidden'
                }
            ],
            Validate: true,
            RequestParam: 'shippingMethodId',
            RequestParamType: 'SingleValue',
            ErrorMsg: 'Step {step}: Please select delivery method'
        },
        selectedPaymentType: {
            Fields: [
                {
                "Name": 'Payment Type',
                "Field": '#billing-payment-type',
                "Param": 'paymentType',
                "Type": 'Hidden'
                }
            ],
            Validate: true,
            RequestParam: 'paymentType',
            RequestParamType: 'SingleValue',
            ErrorMsg: 'Please select payment method type'
        }
    };

    return forms;
});
